import { useState } from 'react'
import { useSnapshot } from 'valtio'
import notificationCenterStore, { setUseNewOptimizationLog } from '../store/notificationCenterStore'

type OptimizationLogPreferenceTooltip = {
  open: boolean
  isEnabled: boolean
  handleMouseEnter: () => void
  handleMouseLeave: () => void
  handleTurnOn: () => void
  handleTurnOff: () => void
}
//TO BE REMOVED WHEN NEW OPTIMIZATION LOG IS FULLY RELEASED

export function useOptimizationLogPreferenceTooltip(): OptimizationLogPreferenceTooltip {
  const { useNewOptimizationLog } = useSnapshot(notificationCenterStore)
  const [open, setOpen] = useState(false)

  const handleMouseEnter = (): void => {
    if (!useNewOptimizationLog) {
      setOpen(true)
    }
  }

  const handleMouseLeave = (): void => {
    setOpen(false)
  }

  const handleTurnOn = (): void => {
    setUseNewOptimizationLog(true)
    setOpen(false)
  }

  const handleTurnOff = (): void => {
    setUseNewOptimizationLog(false)
    setOpen(false)
  }

  return {
    open,
    isEnabled: useNewOptimizationLog,
    handleMouseEnter,
    handleMouseLeave,
    handleTurnOn,
    handleTurnOff,
  }
}
